import Cookies from 'universal-cookie';
export default Cookies;
